import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BOX_IMAGE, heroBadges } from '../data/content';
export function Hero() {
  return <header className="flex min-h-[100svh] w-full flex-col justify-center bg-slate-950 px-5 pb-10 pt-6 text-white" data-id="element-99" data-mp="9kte1nsdw2xr">
      <div className="mx-auto flex w-full max-w-[900px] flex-col items-center text-center" data-id="element-100" data-mp="4m8msdv40tlg">
        <h1 className="text-balance text-[clamp(1.7rem,5vw,3.1rem)] font-extrabold uppercase leading-[0.98] tracking-tight" data-id="element-101" data-mp="1297aw07qkt7q">
          The Done-for-You System to{' '}
          <span className="text-orange-500" data-id="element-102" data-mp="x8b7rov7lb3d">
            Plan an Entire Year of Financial Literacy
          </span>{' '}
          in Just 5 Minutes
        </h1>

        <p className="mt-4 max-w-[680px] text-[clamp(0.9rem,2.5vw,1.05rem)] leading-snug text-white/90" data-id="element-103" data-mp="nb6n5th0hnoo">
          Stop spending hours searching for worksheets, building activities,
          creating assessments, and trying to organize lessons from scratch.
        </p>

        <p className="mt-3 max-w-[680px] text-[clamp(0.9rem,2.5vw,1.05rem)] leading-snug text-white/90" data-id="element-104" data-mp="3j7zfnjujfuh7">
          <strong className="font-extrabold text-white" data-id="element-105" data-mp="3o858h3cjnn0v">
            FINANCIAL LITERACY READY™
          </strong>{' '}
          gives you a{' '}
          <strong className="font-extrabold text-white" data-id="element-106" data-mp="39a378zszjdms">
            complete 36-week teaching system
          </strong>{' '}
          with ready-to-teach lessons, printable worksheets, real-life money
          activities, assessments, answer keys, classroom challenges, and yearly
          planning —{' '}
          <strong className="font-extrabold text-white" data-id="element-107" data-mp="35audvw1uxhrr">
            all organized in one place.
          </strong>
        </p>

        <p className="mt-3 text-[clamp(0.85rem,2.4vw,1rem)] font-bold text-white" data-id="element-108" data-mp="2violil7p0yc1">
          Choose. Open. Teach with confidence.
        </p>

        <img src={BOX_IMAGE} alt="The FINANCIAL LITERACY READY™ Complete Bundle: 6 volumes plus lesson plans, activities, assessments and a yearly planner for Middle & High School teachers" className="mt-5 max-h-[42svh] w-auto max-w-full object-contain" width={1240} height={1240} data-id="element-109" data-mp="2hkgl23bg7ew4" />

        <h2 className="mt-5 text-[clamp(1rem,3vw,1.35rem)] font-extrabold uppercase leading-tight tracking-tight text-white" data-id="element-110" data-mp="ic873bxiq0w9">
          The FINANCIAL LITERACY READY™ Complete Bundle
        </h2>
        <p className="mt-2 max-w-[620px] text-[0.95rem] leading-snug text-white/85" data-id="element-111" data-mp="dbastafmpr01">
          A complete 6-in-1 teaching system designed for Middle & High School
          Financial Literacy teachers who want to walk into class already
          knowing exactly what to teach.
        </p>

        <CtaButton label="Yes! I Want the System" href="#offer" className="mt-6 w-full max-w-[480px]" data-id="element-112" data-mp="114kispa2aej2" />

        <p className="mt-3 text-[clamp(0.7rem,2vw,0.85rem)] font-extrabold uppercase tracking-tight text-orange-500" data-id="element-113" data-mp="3lt756pxsnptq">
          Get FINANCIAL LITERACY READY™ Today
        </p>

        <ul className="mt-3 flex max-w-[760px] flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[clamp(0.6rem,1.8vw,0.72rem)] font-bold uppercase tracking-wide text-white" data-id="element-114" data-mp="1x9kugm9v74h7">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5" data-id="element-115" data-mp="269r7y85kc4gd">
              <CheckIcon className="h-3.5 w-3.5 shrink-0 text-orange-500" strokeWidth={3} aria-hidden="true" data-id="element-116" data-mp="2b0pnh5iq8yik" />
              {badge}
            </li>)}
        </ul>
      </div>
    </header>;
}